import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-skeleton-card-generic',
  imports: [CommonModule],
  templateUrl: './skeleton-card-generic.component.html',
  styleUrl: './skeleton-card-generic.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SkeletonCardGenericComponent {
  @Input() Altura : string = '180'
}
